<template>
    <div class="md-section">
        <div class="md-section-border">
          <img class="md-section-img" :src="image">
        </div>
        <div class="md-section-title">
              <p v-html="title"></p>
        </div>
        <div class="md-section-detail">
            <p v-html="detail"></p>
        </div>
        <div class="md-section-button">
          <div class="is-inline-block-tablet">
              <span
                class="has-text-black md-section-button-addtocart"
                @click="$emit('gotoAddToCart')"
                ><img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-21_3FAvK38RTWt.png"
                  class="md-button-white"
                  />
                </span
              >
            </div>
            <div class="md-button-section-compare">
              <span
                class="has-text-black md-section-button-compare"
                @click="$emit('openModal')"
              >
                <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-29_1EIDxCmnk.png"
                  class="md-button-white"
                  />
              </span>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  name: 'ProductCompareDetail',
  props: {
    title: {
      type: String,
      required: true,
    },
    detail: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.active{
  border-right: burlywood 1px solid;
  padding-right: 20px;
}
.md-section{
      //  width: 80%;
       margin-left: auto;
       margin-right: auto;
      //  padding: 20px;
      //  margin: -8%;
    &-img{
        width: 100%;
        height: auto;
        // border: 1px solid lightgrey;
        max-height: 480px;
        @media screen and (max-width: 900px) {
        max-height: 150px;
        height: auto;
        width: 100%;
      }
    }
     &-border{
        // border: 1px solid lightgrey;
        height: 380px;
        @media screen and (max-width: 900px) {
          height: 180px;
        }
      }
    &-title{
       font-size: 20px;
       font-weight: bold;
       text-align: left;
       width: 100%;
       margin-left: auto;
       margin-right: auto;
       padding-bottom: 10px;
       border-bottom: 1px solid #FFB900;
       height:80px;
       margin-top: 80px;
       @media screen and (max-width: 900px) {
        font-size: 15px;
        text-align: left;
        margin-top: 0px;
      }
    }
    &-detail{
       font-size: 20px;
       text-align: left;
       width: 100%;
       margin-left: auto;
       margin-right: auto;
       height: 500px;
       max-height: 500px;
       margin-top: 10px;
       @media screen and (max-width: 900px) {
        font-size: 10px;
        text-align: left;
      }
    }
    &-button{
        height: 90px;
        &-addtocart img{
          cursor: pointer;
        }
        &-compare img{
          cursor: pointer;
        }
    }
}
</style>
